import { store } from "../../store";
import { userLogout } from "../../store/auth/auth.slice";
import { authApi } from "../../store/auth/auth.api";

let verificationInterval;

export const startTokenVerification = () => {
  // Clear any existing interval
  if (verificationInterval) {
    clearInterval(verificationInterval);
  }

  // Set up periodic token verification (every 5 minutes)
  verificationInterval = setInterval(() => {
    const state = store.getState();
    const token = state.auth?.tokens?.access_token;

    if (token) {
      // Trigger token verification
      store
        .dispatch(authApi.endpoints.verifyToken.initiate(null))
        .unwrap()
        .catch(() => {}); // Errors handled by slice
    }
  }, 30 * 1000); // 30 seconds

  // Initial verification after a delay to prevent immediate check after login
  const state = store.getState();
  if (state.auth?.tokens?.access_token) {
    setTimeout(() => {
      store
        .dispatch(authApi.endpoints.verifyToken.initiate(null))
        .unwrap()
        .catch(() => {});
    }, 5000); // 5 second delay for initial check
  }
};

export const stopTokenVerification = () => {
  if (verificationInterval) {
    clearInterval(verificationInterval);
    verificationInterval = null;
  }
};

// Subscribe to store to handle auth state changes
store.subscribe(() => {
  const state = store.getState();
  const token = state.auth?.tokens?.access_token;

  // Start verification when token exists, stop when it doesn't
  if (token && !verificationInterval) {
    startTokenVerification();
  } else if (!token && verificationInterval) {
    stopTokenVerification();
  }
});
